/*
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-31 21:27:30
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-04-08 19:34:37
 * @FilePath: \hippo-web-admin\src\config\setting.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-31 21:27:30
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-04-04 21:46:59
 * @FilePath: \hippo-web-admin\src\config\setting.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 不显示侧栏的路由
export const HIDE_SIDEBARS = [];

// 不显示页脚的路由
export const HIDE_FOOTERS = [
  '/system/dictionary',
  '/system/organization',
  '/form/advanced',
  '/example/choose'
];

// 页签同路由不同参数可重复打开的路由
export const REPEATABLE_TABS = ['/system/user-info'];

// 不需要登录的路由
export const WHITE_LIST = [
  '/login',
  '/forget',
  '/reportPdf',
  '/report/en',
  '/report/zh',
  '/report/cs',
  '/report/it',
  '/report/ar',
  '/report/sl',
  '/report/hr',
  '/report/bg',
  '/report/hy'
];

// 直接指定菜单数据
export const USER_MENUS = null;

// token传递的header名称
export const TOKEN_HEADER_NAME = 'xToken';

// token存储的名称
export const TOKEN_STORE_NAME = 'access_token';

// 主题配置存储的名称
export const THEME_STORE_NAME = 'theme';

// 首页名称, 为空则取第一个菜单的名称
export const HOME_TITLE = 'Home';

// 首页路径, 为空则取第一个菜单的地址
export const HOME_PATH = null;

// 顶栏是否显示主题设置按钮
export const ENABLE_SETTING = false;

// 开启多页签后是否缓存组件
// export const TAB_KEEP_ALIVE = process.env.NODE_ENV !== 'development';
export const TAB_KEEP_ALIVE = false;

// 当前登录用户角色
export const USER_LOGIN_TYPE = 'user_login_type';

// 当前系统的血糖单位
export const BLOOD_SUGAR_UNIT = 'blood_sugar_unit';

// 导出页面的url中的token名称
export const EXPORT_PDF_TOKEN = 'internalXToken';
